import React from 'react';
import loadable from '@loadable/component';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { breakpoints } from '@naf/theme';
import { MapV2 } from '@components/SectionBlocks/blocks/Charts/MapV2';
import { colors } from '@naf-simba/theme';
import { PointOfInterest } from '../../../../SectionBlocks/blocks/Charts/RouteCharts';
import { useElPrixRouteData } from '../../../../../hooks/useElPrixRouteData';

const GoogleMapsWrapper = loadable(() => import('../../../../SectionBlocks/blocks/Charts/GoogleMapsWrapper'), {
  resolveComponent: (m) => m.GoogleMapsWrapper,
});

type Props = {
  inArticle?: boolean;
  value: {
    _key: string;
    _type: 'routeMap';
  } & (CustomRouteMapData | TestRouteMapData);
};

type TestRouteMapData = {
  useRouteFromTest: true;
  elPrixTestReference: { routepoints: PointOfInterest[]; altitudeProfile: number[] };
};
type CustomRouteMapData = { useRouteFromTest: false; routepoints: PointOfInterest[]; altitudeProfile: number[] };

const RouteMapSerializer =
  () =>
  ({ value, inArticle }: Props) => (
    <GoogleMapsWrapper>
      <RenderRouteMap value={value} inArticle={inArticle || false} />
    </GoogleMapsWrapper>
  );

const RenderRouteMap = ({ value, inArticle }: Props) => {
  const { routepoints, altitudeProfile } = value.useRouteFromTest === true ? value.elPrixTestReference : value;

  const { pointsOfInterest, routeData, isLoading } = useElPrixRouteData({
    routepoints,
    elevation: altitudeProfile,
  });

  return (
    <MapContainer inArticle={inArticle}>
      <MapV2
        animate
        mapOptions={{
          animatedPathStroke: colors.secondary[500],
        }}
        routeData={routeData}
        pointsOfInterest={pointsOfInterest}
        isLoading={isLoading}
        zoom={6}
        center={{ lat: 61.26921, lng: 10.40559 }}
        style={{ height: '100%' }}
      />
    </MapContainer>
  );
};

const MapContainer = styled.div<{ inArticle: boolean }>`
  height: 440px;

  ${({ inArticle }) =>
    inArticle
      ? css``
      : css`
          width: 100%;
        `}

  grid-column: 3 / -3;

  @media (max-width: ${breakpoints.m}) {
    grid-column: 1 / -1;
  }
`;

export { RouteMapSerializer };
